import React from 'react';
import { TableTagProps } from './interfaces';
import './TableTag.scss';

export const TableTag: React.FC<TableTagProps> = (props) => {
    const { tagText } = props;

    return (
        <div className='ui-table-tag'>
            <span className='ui-table-tag__inner'>{tagText}</span>
        </div>
    );
};
